
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 99"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.3 47.3h18v4.5h-18v18h-4.5v-18h-18v-4.5h18v-18h4.5v18zM77.5 75c-7 7-16.2 10.5-25.5 10.5-9.2 0-18.4-3.5-25.5-10.5-14.1-14.1-14.1-36.9 0-50.9 7-7 16.2-10.5 25.5-10.5 9.2 0 18.4 3.5 25.5 10.5 14 14 14 36.8 0 50.9zm-3.2-47.8C68.3 21.3 60.4 18 52 18s-16.3 3.3-22.3 9.2c-12.3 12.3-12.3 32.3 0 44.6 6 5.9 13.9 9.2 22.3 9.2s16.3-3.3 22.3-9.2c12.3-12.3 12.3-32.3 0-44.6z"}})])
          )
        }
      }
    